import { Box, styled } from "@mui/material";
import { Link } from "react-router-dom";
import connectLogo from "../../../assets/img/hacs-logo.svg";

const LogoWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "220px",
  height: "auto",
  
  // Desktop default
  "& img": {
    width: "180px",
    height: "auto",
  },

  // Tablet size
  [theme.breakpoints.down("md")]: {
    width: "90px",
    "& img": {
      width: "85%",
    },
  },

  // Mobile size
  [theme.breakpoints.down("sm")]: {
    width: "80px",
    display:"flex",
    justifyContent:"flex-start",
    "& img": {
      width: "80%",
    },
  },
}));

function Logo() {
  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <LogoWrapper>
        <img src={connectLogo} alt="Logo" />
      </LogoWrapper>
    </Link>
  );
}

export default Logo;
